import { render, staticRenderFns } from "./screens.vue?vue&type=template&id=13795a08&scoped=true&"
import script from "./screens.vue?vue&type=script&lang=js&"
export * from "./screens.vue?vue&type=script&lang=js&"
import style0 from "./screens.vue?vue&type=style&index=0&id=13795a08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13795a08",
  null
  
)

export default component.exports